import {useStorage} from "@variocube/app-ui";

export function useHelpStorage() {
	return useStorage("help", true);
}
